import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    instruction: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "16px",
        },
    },
    boxContainer: {
        width: "100%",
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(6),
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            color: theme.palette.corporateBO.checkbox,
            "&.Mui-checked": {
                color: theme.palette.info.main,
            },
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            background: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
    cancelButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.dark,
        },
    },
    setupMillLink: {
        fontWeight: "bold",
        textDecoration: "underline",
        cursor: "pointer",
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
        gap: 4,
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    modalBody: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: theme.spacing(6),
        padding: "20px 30px 0",
    },

    modalAccordionContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    footer: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        gap: theme.spacing(4),
        justifyContent: "flex-end",
        width: "100%",
    },
    button: {
        "&.MuiButton-root": {
            fontFamily: "Source Sans 3 !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
            color: `${theme.palette.primary.dark} !important`,
        },
    },
    submitButton: {
        "&.MuiButton-root": {
            fontFamily: "Source Sans 3 !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    card: {
        background: `${theme.palette.primary.main} !important`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15) !important",
        borderRadius: "4px !important",
        "&::before": {
            content: "none !important",
        },
        "& .Mui-expanded": {
            minHeight: "0 !important",
        },
    },
    cardHeader: {
        padding: "12px 22px !important",
        display: "flex !important",
        borderBottom: `1px solid ${theme.palette.border.select} !important`,
        "& .MuiAccordionSummary-content": {
            alignItems: "center !important",
            margin: "0 !important",
            gap: 8,
        },
    },
    cardTitle: {
        fontSize: 18,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        color: theme.palette.info.main,
    },
    cardBody: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    cardBodyContent: {
        padding: "14px 14px 4px 14px",
        display: "flex",
        flexWrap: "wrap",
        gap: 14,
    },
    cardAlert: {
        padding: "0px 16px !important",
    },
    cardHeaderIcon: {
        transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    },
}));
